"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ModalHeader2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _Illustration = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _context = require("../../../../../services/log/context");
var _ChevronForward2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronForward"));
var _AccountCircle2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/AccountCircle"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Stack2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Separator = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _events = require("../../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
var _ModalHeader, _AccountCircle, _FormattedMessage, _Stack, _ChevronForward, _FormattedMessage2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ButtonWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "RequiredLogin__ButtonWrapper",
  componentId: "sc-1vkqpwr-0"
})(["button,a{& > div:first-child{justify-content:center;& > div:last-child{width:auto;}}}"]);
const RequiredLoginScreen = ({
  onHandleToIntro,
  onHandleContinueAsGuest
}) => {
  const {
    log
  } = (0, _context.useLog)();
  const handleOnSignIn = (0, React.useCallback)(() => {
    log(_events.REQUIRED_LOGIN_SIGN_IN_CLICKED, {});
    onHandleToIntro();
  }, [log, onHandleToIntro]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [_ModalHeader || (_ModalHeader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader2.default, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.required_login.header"
      }),
      illustration: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration.default, {
        name: "Login",
        size: "extraSmall"
      }),
      description: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.required_login.description"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalSection.default, {
      dataTest: "MagicLogin-RequiredLogin",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          fullWidth: true,
          spaceAfter: "medium",
          iconLeft: _AccountCircle || (_AccountCircle = /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccountCircle2.default, {
            ariaHidden: true
          })),
          type: "primary",
          onClick: handleOnSignIn,
          dataTest: "MagicLogin-SignInButton",
          children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.sign_in"
          }))
        })
      }), _Stack || (_Stack = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack2.default, {
        direction: "row",
        align: "center",
        spaceAfter: "medium",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          as: "span",
          type: "primary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "common.or"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator.default, {})]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack2.default, {
        align: "center",
        direction: "column",
        spaceAfter: "small",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
          onClick: onHandleContinueAsGuest,
          type: "secondary",
          size: "normal",
          iconRight: _ChevronForward || (_ChevronForward = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronForward2.default, {})),
          dataTest: "MagicLogin-GuestTextLink",
          children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.required_login.text_link.guest"
          }))
        })
      })]
    })]
  });
};
var _default = RequiredLoginScreen;
exports.default = _default;